var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "distribute-detail" },
    [
      _vm.$route.meta
        ? _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$route.meta.title)),
          ])
        : _vm._e(),
      _c(
        "Detail",
        {
          ref: "getTable",
          attrs: {
            tableData: _vm.tableForm,
            tableFormAttrs: _vm.tableFormAttrs,
            filterDataRules: _vm.filterDataRules,
            formLabelWidth: "110px",
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.expireOrder()
                },
              },
            },
            [_vm._v("作废")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }